module.exports = __webpack_public_path__ + "fonts/opensans-semibolditalic.38d62493.woff";